import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getChecksSelector} from "./PaymentCardsSelectors";
import PaymentTypeDetails from "./PaymentTypeDetails";

export class ChecksList extends Component {

  render() {

    return <div>{
      this.props.checks.map((check, index) => {
        return <div key={index}><PaymentTypeDetails payment_card={check} onEdit={this.props.onEdit} onDelete={this.props.onDelete}/></div>
      })
    }{
      this.props.checks.length === 0 && <span>No eChecks associated with this account.</span>
    }</div>
  }
}

ChecksList.propTypes = {
  checks: PropTypes.array,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default connect((state, props) => {
  return {
    checks: getChecksSelector(state, props),
  }
})(ChecksList);
